import Select from "react-select";
import { getOptions } from "@services/axios";
import React, { useEffect, useState } from "react";
const ISelect = ({
  id,
  name,
  label,
  value,
  handleChange,
  data,
  route = false,
  isMulti = false,
  isSearchable = true,
  isClearable = true,
  height = 50,
}) => {
  const [selectedOption, setSelectedOption] = useState(data);

  const customTheme = (theme) => ({
    ...theme,
    spacing: {
      ...theme.spacing,
      controlHeight: height, // Default is 38
      baseUnit: 5, // Default is 4. Controls padding, margins, etc.
    },
  });

  const customStyles = {
    control: (provided) => ({
      ...provided,
      height: `${height}px`,
      border: "1px solid #ced4da",
      borderRadius: "0.5rem",
      boxShadow: "none",
      paddingLeft: "10px",
      fontSize: "1rem",
      backgroundColor: "#fff",
      color: "#000",
      "&:hover": {
         borderColor: "var(--primary-blue)",
      },
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  useEffect(() => {
    if (route === false) {
      return;
    }
    const preload = async () => {
      try {
        const result = await getOptions(route);

        setSelectedOption(result);
      } catch (err) {}
    };

    preload();
  }, [route]);

  return (
    <>
      <Select
        theme={customTheme}
        defaultValue={value}
        onChange={handleChange}
        options={selectedOption}
        id={id}
        name={name}
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        placeholder={label}
        menuPortalTarget={document.body}
        menuPosition={"fixed"}
        styles={customStyles}
      />
    </>
  );
};

export default ISelect;
